import React, {useEffect} from "react"
import FormattedMessage from "@irati/utils/lang"
import {H1, H3} from "@irati/ui/src/Typography"
import {RouteComponentProps} from "react-router-dom"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import tracking from "@irati-tracking/wellness"
import {WellnessScissorsIcon} from "../components/WellnessScissorsIcon"

type Props = RouteComponentProps<{}, {}>

export const NotFound = () => {
  useEffect(() => {
    tracking.wellnessViewErrorPage()
  }, [])

  return (
    <Flex direction="column" gap={3} marginTop={3}>
      <Flex alignItems="center" gap={2}>
        <Icon icon={IconTypes.arrowLeft} />
        <ButtonRouterLink className="btn-xs" small to={`/`}>
          <FormattedMessage id="wellness.title" />
        </ButtonRouterLink>
      </Flex>

      <Flex direction="column" margin={"auto"} alignItems={"center"} gap={3}>
        <Flex gap={2} alignItems="center" marginBottom>
          <WellnessScissorsIcon size="large" />
        </Flex>

        <H1>
          <FormattedMessage id="wellness.nothingFound.title" />
        </H1>

        <H3>
          <FormattedMessage id="wellness.nothingFound.description" />
        </H3>

        <div>
          <ButtonRouterLink primary to={`/`}>
            <FormattedMessage id="wellness.nothingFound.button" />
          </ButtonRouterLink>
        </div>
      </Flex>
    </Flex>
  )
}
